import { getAuthStorage } from 'shared/helpers/impersonation';

export const getAccessToken = (): string | undefined => {
	const authStore = getAuthStorage().getItem('authStore');
	return (authStore && JSON.parse(authStore)?.state?.accessToken) ?? undefined;
};
